<template>
  <c-base-dialog
    v-model="isShow"
    :option="option"
    @close="$emit('close')"
    @confirm="$emit('close')"
  >
    <template slot="body">
      <div class="reward">
        <div>恭喜你获得了</div>
        <div v-if="icon" :class="[isMobile ? 'img-box-h5' : 'img-box-pc']">
          <img :src="icon" :class="[isMobile ? 'img-h5' : 'img-pc']" />
        </div>
        <div>{{ packageData.package_name }}</div>
      </div>
    </template>
    <template slot="fotter">
      <div v-if="checkGiftType('packageRealGift')" :style="actionStyle">
        <img
          class="ceiba-base-dialog-ft-button"
          :style="inputAddressStyle"
          @click="signAddress"
        >
        <div class="address-tips">提示：实物奖励需填写地址才可以收到.~</div>
      </div>
      <div v-if="checkGiftType('cdk')" :style="actionStyle">
        <p class="cdk-tips">CDK: {{ packageData.package_cdkey }}</p>
        <div :style="actionStyle" class="cdk-action-button">
          <div
            :style="copyStyle"
            @click="copyCDkText"
          ></div>
          <div
            :style="downloadGameButtonStyle"
            @click="startCallDownload"
          ></div>
        </div>
      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import CDialog from '../base-dialog';
export default {
  name: 'GiftComponent',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    icon: String,
    packageData: Object,
    option: Object,
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      isShow: true,
      isOpenDownload: true,
      copyCdkIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/copyCDk.png',
      downloadGameIconImage: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      packageRealGiftInputIcon: 'https://game.gtimg.cn/images/js/img/tgclub/downloadInit.png',
      copyCdkSuccessTrips: '',
    };
  },
  computed: {
    actionStyle() {
      return {
        width: this.option.width,
      };
    },
    inputAddressStyle() {
      return {
        display: 'block',
        backgroundImage: `url(${this.packageRealGiftInputIcon})`,
        margin: '0 auto',
      };
    },
    copyStyle() {
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundImage: `url(${this.copyCdkIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        margin: '0 0',
      };
    },
    downloadGameButtonStyle() {
      return {
        width: '2.2rem',
        height: '0.65rem',
        display: this.isOpenDownload ? 'block' : 'none',
        backgroundImage: `url(${this.downloadGameIconImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        margin: '0 0',
      };
    },
  },
  methods: {
    closeBtnClick() {
      this.isShow = false;
    },
    initValue() {
      this.copyCdkSuccessTrips = '';
      this.copyCdkIconImage = '';
      this.downloadGameIconImage = '';
      this.isOpenDownload = false;
      this.packageRealGiftInputIcon = '';
    },
    checkGiftType(checkType) {
      this.initValue();
      const packageId = this.packageData.package_id;
      if (packageId === 0 || !packageId) return false;
      const receiveGiftCustomConfig = this.$actInfo?.extendConfig?.receiveGiftCustomConfig ?? [];
      console.log('receiveGiftCustomConfig = ', receiveGiftCustomConfig);
      const res = receiveGiftCustomConfig?.find(item => parseInt(item.gift_id, 10) === parseInt(packageId, 10));
      console.log(res, 'isres', this.option, 'isoption');
      const { type = '' } = res || {};
      if (type === 'cdk' && checkType === 'cdk') {
        this.copyCdkSuccessTrips = res?.playload?.copyCdkSuccessTrips ?? '复制成功';
        this.copyCdkIconImage = res?.playload?.copyCdkIconImage ?? '';
        this.downloadGameIconImage = res?.playload?.downloadGameIconImage ?? '';
        this.isOpenDownload = parseInt(res?.playload?.isOpenDownload ?? 1, 10) === 2;
        return true;
      }
      if (type === 'packageRealGift' && checkType === 'packageRealGift') {
        this.packageRealGiftInputIcon = res?.playload?.packageRealGiftInputIcon ?? '';
        return true;
      }
      return false;
    },
    async signAddress() {
      console.log('signAddress');
      this.isShow = false;
      this.$eventBus.$emit('ceiba:common:events:address-fill', {});
    },
    startCallDownload() {
      console.log('startCallDownload');
      this.$eventBus.$emit('ceiba:common:events:call-game-download', {});
    },
    copyCDkText() {
      const textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      textarea.value = this.packageData.package_cdkey;
      textarea.select();
      document.execCommand('copy', true);
      document.body.removeChild(textarea);
      this.$toast(this.copyCdkSuccessTrips || '复制cdk成功');
      return true;
    },
  },
};
</script>

<style lang="scss">
.img-box-h5 {
  width: 1.35rem;
  height: 1.35rem;
  margin: 0 auto;
  position: relative;
  background: #f7f7f7;
  border-radius: 0.183rem;
}

.img-box-pc {
  width: 135px;
  height: 135px;
  margin: 0 auto;
  position: relative;
  background: #f7f7f7;
  border-radius: 0.183rem;
}

.img-h5 {
  position: absolute;
  background-repeat: no-repeat;
  width: 1.35rem;
  height: 1.35rem;
}

.img-pc {
  position: absolute;
  background-repeat: no-repeat;
  width: 135px;
  height: 135px;
}

.address-tips {
  text-align: center;
  margin-top: 0.2rem;
}

.cdk-action-button {
  display: flex;
  justify-content: space-around;
}

.cdk-tips {
  text-align: center;
  margin-bottom: 0.3rem;
}
</style>
